import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { IoMdArrowRoundForward, IoMdArrowRoundBack } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './feedback.css';
import { BASE_URL } from "../../BaseUrl";
import {
  getSystemSettings,
  getCookie
} from "../../functions/Functions";
import { SettingsContext } from "../../contexts/Settings";
import axios from "axios";
import CustomSpinLoader from "../components/CustomSpinLoader";

const Feedback = () => {
  const {id} = useParams();
  const {generalSettings} = useContext(SettingsContext);
  
  const merchantSettings = {
    feedbackLayout: {
      title: "We Value Your Feedback",
      description: "Please share your experience with us",
      formBGColor: "rgba(255, 255, 255, 0.92)",
      backgroundImageUrl: "/assets/posbg.png",
      titleColor: "white",
      overlayColor: "rgba(0, 0, 0, 0.4)",
    },
    staticPageTitleForReviewForm: "Feedback Form",
    favicon: "/favicon.ico",
    staticPageDescriptionForReviewForm: "Share your feedback with us",
  };

  const feedbackCategories = [
    {
      title: "Food",
      description: "How was our Food experience?",
      emojis: [
        { label: "Excellent", symbol: "😍", rating: "Excellent" },
        { label: "Good", symbol: "😊", rating: "Good" },
        { label: "Average", symbol: "😐", rating: "Average" },
        { label: "Poor", symbol: "🙁", rating: "Poor" },
        { label: "Terrible", symbol: "😠", rating: "Terrible" }
      ],
    },
    {
      title: "Service",
      description: "Was the service on time?",
      emojis: [
        { label: "Excellent", symbol: "😍", rating: "Excellent" },
        { label: "Good", symbol: "😊", rating: "Good" },
        { label: "Average", symbol: "😐", rating: "Average" },
        { label: "Poor", symbol: "🙁", rating: "Poor" },
        { label: "Terrible", symbol: "😠", rating: "Terrible" }
      ],
    },
    {
      title: "Ambience",
      description: "How was the Ambience?",
      emojis: [
        { label: "Excellent", symbol: "😍", rating: "Excellent" },
        { label: "Good", symbol: "😊", rating: "Good" },
        { label: "Average", symbol: "😐", rating: "Average" },
        { label: "Poor", symbol: "🙁", rating: "Poor" },
        { label: "Terrible", symbol: "😠", rating: "Terrible" }
      ],
    },
  ];

  const [step, setStep] = useState(1);
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [formData, setFormData] = useState({
    orderData: null,
    name: "",
    email: "",
    phone: "",
    generalFeedback: "",
    overAllrating: "",
    categoryFeedbacks: {},
    ratings: {},
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [animation, setAnimation] = useState("fadeIn");

  const getFeedback = async() =>{
    setLoading(true);
    try{
      const url = BASE_URL + `/settings/feedback-check/${id}`;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        setLoading(false);
        if(res.data.status === 0){
          toast.error(res.data.message,{
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            className: "text-center toast-notification",
            toastId: "feedback-error-1"
          });
          setFormData((curr)=>({
            ...curr,
            orderData:null
          }));
          return
        }
        setFormData((curr)=>({
          ...curr,
          orderData:res.data
        }));
      }
    }catch(err){
      setLoading(false);
      if(err.response.data?.status === 0){
        toast.error(err.response.data.message,{
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          className: "text-center toast-notification",
          toastId: "feedback-error-2"
        });
        return
      }
      toast.error("Please try again", { toastId: "feedback-error-try-again" });
    }
  }

  useEffect(()=>{
    getFeedback()
  },[])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCategoryFeedbackChange = (category, value) => {
    setFormData((prev) => ({
      ...prev,
      categoryFeedbacks: {
        ...prev.categoryFeedbacks,
        [category]: value,
      },
    }));
  };

  const handleRatingSelect = (category, rating) => {
    if (category === "overall") {
      setFormData((prev) => ({
        ...prev,
        overAllrating: rating,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        ratings: { ...prev.ratings, [category]: rating },
      }));
    }
  };

  const animateAndNext = (nextFunction) => {
    setAnimation("fadeOut");
    setTimeout(() => {
      nextFunction();
      setAnimation("fadeIn");
    }, 300);
  };

  const nextStep = () => {
    const { name, email, phone } = formData;
    if (!name || !phone) {
      toast.warning("Please fill all required fields", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: "text-center toast-notification",
        toastId: "feedback-warning-required"
      });
      return;
    }
    animateAndNext(() => setStep(2));
  };

  const prevStep = () => {
    setAnimation("fadeOut");
    setTimeout(() => {
      if (currentCategoryIndex === 0) {
        setStep(1);
      } else {
        setCurrentCategoryIndex(currentCategoryIndex - 1);
      }
      setAnimation("fadeIn");
    }, 300);
  };

  const nextCategory = () => {
    const currentCategory = feedbackCategories[currentCategoryIndex].title;
    if (!formData.ratings[currentCategory]) {
      toast.warning(`Please rate ${currentCategory.toLowerCase()}`, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: "text-center toast-notification",
        toastId: "feedback-warning-rate"
      });
      return;
    }
    
    animateAndNext(() => {
      if (currentCategoryIndex < feedbackCategories.length - 1) {
        setCurrentCategoryIndex(currentCategoryIndex + 1);
      } else {
        setStep(3);
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.overAllrating) {
      toast.warning("Please provide an overall rating", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: "text-center toast-notification",
        toastId: "feedback-warning-overall"
      });
      return;
    }
    
    setLoading(true);
    try {
      const payload = {
        type:"form",
        order_id: formData.orderData.order_id,
        token: formData.orderData.token,
        order_date: formData.orderData.order_date,
        branch_id: formData.orderData.branch_id,
        branch_name: formData.orderData.branch_name,
        total_payable: formData.orderData.total_payable,
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        generalFeedback: formData.generalFeedback,
        overAllrating: formData.overAllrating,
        category: {
          foodFeedback: formData.categoryFeedbacks[feedbackCategories[0].title] || "",
          foodRating: formData.ratings[feedbackCategories[0].title] || "",
          servingFeedBack: formData.categoryFeedbacks[feedbackCategories[1].title] || "",
          servingRating: formData.ratings[feedbackCategories[1].title] || "",
          ambienceFeedBack: formData.categoryFeedbacks[feedbackCategories[2].title] || "",
          ambienceRating: formData.ratings[feedbackCategories[2].title] || "",
        }
      };

      
      const url = BASE_URL + `/settings/customer-feedback`;
      const res = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        toast.success("Feedback submitted successfully", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          className: "text-center toast-notification",
          toastId: "feedback-success"
        });
        setAnimation("fadeOut");
        setTimeout(() => {
          setSubmitted(true);
          setAnimation("fadeIn");
        }, 300);
      }

    } catch (err) {
      if(err.response.data?.status === 0){
        toast.error(err.response.data.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          className: "feedback-toast",
          bodyClassName: "toast-body",
          progressClassName: "toast-progress",
          toastId: "feedback-error-submit"
        });
        return;
      }
      toast.error("Failed to submit feedback. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: "feedback-toast",
        bodyClassName: "toast-body",
        progressClassName: "toast-progress",
        toastId: "feedback-error-failed"
      });
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      orderData: null,
      name: "",
      email: "",
      phone: "",
      generalFeedback: "",
      overAllrating: "",
      categoryFeedbacks: {},
      ratings: {},
    });
    setStep(1);
    setCurrentCategoryIndex(0);
    setSubmitted(false);
  };

  const backgroundImageUrl = merchantSettings?.feedbackLayout?.backgroundImageUrl;
  const overlayColor = merchantSettings?.feedbackLayout?.overlayColor || "rgba(0, 0, 0, 0.3)";

  return (
    <>
      <CustomSpinLoader loading={loading}/>
      <div 
        className="feedback-page"
        style={{
          // backgroundImage: `linear-gradient(${overlayColor}, ${overlayColor}), url(${backgroundImageUrl})`,
          background: `linear-gradient(135deg, #0e9273ff 0%, #0a8d6e 50%, #044e3cff 100%)`,
        }}
      >
        <div className="feedback-img">
          <div className="feedback-container mx-auto">
            <div className="d-flex justify-content-center w-100">
              <img 
                src={
                  `${getSystemSettings(
                    generalSettings,
                    "type_logo"
                  )}`
                }
                alt="logo"
                className="mb-2 rounded"
                style={{ width: "8rem" }}
              />
            </div>
            {!submitted && formData.orderData ? (
              <form onSubmit={handleSubmit} className="feedback-form">
                <div className="mb-1 mx-2 d-flex align-items-center justify-content-between">
                  <div className="feedback-description text-white mr-3">Token: {formData.orderData.token}</div>
                  <div className="feedback-description text-white">Branch: {formData.orderData.branch_name}</div>
                </div>
                <div className={`feedback-card ${animation}`}>
                  <div className="text-center">
                    <h2 className="feedback-title">
                      {merchantSettings?.feedbackLayout?.title}
                    </h2>
                  </div>

                  {step === 1 && (
                    <div className="form-step-1">
                      <div className="feedback-inputGroup">
                        <label htmlFor="name" className="input-label">
                          Your Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          placeholder="Ali Ahmed"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          className="form-input"
                        />
                      </div>
                      <div className="feedback-inputGroup">
                        <label htmlFor="phone" className="input-label">
                          Your Phone Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          placeholder="03000-0000000"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          className="form-input"
                        />
                      </div>
                      <div className="feedback-inputGroup">
                        <label htmlFor="email" className="input-label">
                          Your Email 
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          placeholder="ali@example.com"
                          value={formData.email}
                          onChange={handleChange}
                          className="form-input"
                        />
                      </div>
                      <div className="form-actions single-action">
                        <button
                          type="button"
                          onClick={nextStep}
                          className="feedback-btn btn-primary"
                        >
                          <span>Continue</span>
                          <IoMdArrowRoundForward className="btn-icon" />
                        </button>
                      </div>
                    </div>
                  )}

                  {step === 2 && (
                    <div className="form-step-2">
                      <div className="category-section">
                        <div className="category-header">
                          <h3 className="rating-title">
                            {feedbackCategories[currentCategoryIndex].title}
                          </h3>
                          <p className="feedback-description">
                            {feedbackCategories[currentCategoryIndex].description}
                          </p>
                          <div className="progress-indicator">
                            Step {currentCategoryIndex + 1} of {feedbackCategories.length}
                          </div>
                        </div>

                        <div className="emoji-rating">
                          {feedbackCategories[currentCategoryIndex].emojis.map((emoji) => (
                            <div
                              key={emoji.rating}
                              className={`emoji ${
                                formData.ratings[feedbackCategories[currentCategoryIndex].title] === emoji.rating
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                handleRatingSelect(
                                  feedbackCategories[currentCategoryIndex].title,
                                  emoji.rating
                                )
                              }
                            >
                              <span className="emoji-symbol">{emoji.symbol}</span>
                              <span className="emoji-label">{emoji.label}</span>
                            </div>
                          ))}
                        </div>

                        <div className="feedback-inputGroup">
                          <label
                            htmlFor={`feedback-${feedbackCategories[currentCategoryIndex].title}`}
                            className="input-label color-black Yourcomments"
                          >
                            Your comments about {feedbackCategories[currentCategoryIndex].title.toLowerCase()}
                          </label>
                          <textarea
                            id={`feedback-${feedbackCategories[currentCategoryIndex].title}`}
                            rows="2"
                            placeholder={`What specifically about ${feedbackCategories[currentCategoryIndex].title.toLowerCase()} did you like or dislike?`}
                            value={
                              formData.categoryFeedbacks[feedbackCategories[currentCategoryIndex].title] || ""
                            }
                            onChange={(e) =>
                              handleCategoryFeedbackChange(
                                feedbackCategories[currentCategoryIndex].title,
                                e.target.value
                              )
                            }
                            className="form-textarea"
                          />
                        </div>
                      </div>

                      <div className="form-actions">
                        <button
                          type="button"
                          onClick={prevStep}
                          className="feedback-btn"
                          style={{
                            backgroundColor: "#828282",
                            color: "#fff",
                          }}
                        >
                          <IoMdArrowRoundBack className="btn-icon" />
                          <span>Back</span>
                        </button>
                        <button
                          type="button"
                          onClick={nextCategory}
                          className="feedback-btn btn-primary"
                        >
                          <span>
                            {currentCategoryIndex < feedbackCategories.length - 1
                              ? "Next"
                              : "Continue"}
                          </span>
                          <IoMdArrowRoundForward className="btn-icon" />
                        </button>
                      </div>
                    </div>
                  )}

                  {step === 3 && (
                    <div className="form-step-3">
                      <div className="category-section">
                        <div className="category-header">
                          <h3 className="rating-title">Overall Experience</h3>
                          <p className="feedback-description">
                            How would you rate your overall experience?
                          </p>
                        </div>

                        <div className="emoji-rating">
                          {feedbackCategories[0].emojis.map((emoji) => (
                            <div
                              key={`overall-${emoji.rating}`}
                              className={`emoji ${
                                formData.overAllrating === emoji.rating
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                handleRatingSelect("overall", emoji.rating)
                              }
                            >
                              <span className="emoji-symbol">{emoji.symbol}</span>
                              <span className="emoji-label">{emoji.label}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="feedback-inputGroup">
                        <label htmlFor="generalFeedback" className="input-label">
                          Additional Feedback
                        </label>
                        <textarea
                          id="generalFeedback"
                          name="generalFeedback"
                          rows="2"
                          placeholder="Any other comments about your experience?"
                          value={formData.generalFeedback}
                          onChange={handleChange}
                          className="form-textarea"
                        />
                      </div>

                      <div className="form-actions">
                        <button
                          type="button"
                          onClick={() => {
                            setAnimation("fadeOut");
                            setTimeout(() => {
                              setCurrentCategoryIndex(feedbackCategories.length - 1);
                              setStep(2);
                              setAnimation("fadeIn");
                            }, 300);
                          }}
                          className="feedback-btn"
                          style={{
                            backgroundColor: "#828282",
                            color: "#fff",
                          }}
                        >
                          <IoMdArrowRoundBack className="btn-icon" />
                          <span>Back</span>
                        </button>
                        <button
                          type="submit"
                          className="feedback-btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? (
                            <span className="spinner"></span>
                          ) : (
                            <>
                              <span>Submit Feedback</span>
                              <IoMdArrowRoundForward className="btn-icon" />
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </form>
            ) : (
              !formData.orderData ? (
                <div className={`thank-you-card mt-3 ${animation} mx-auto`}>
                  <p>You can’t submit feedback for this order.</p>
                </div>
              ) : (
                <div className={`thank-you-card mt-3 ${animation} mx-auto`}>
                  <div className="thank-you-content">
                    <div className="checkmark">✓</div>
                    <h2 className="feedback-title">Thank You!</h2>
                    <p>Your feedback has been submitted successfully.</p>
                    <p className="mb-4">We appreciate your time and valuable input.</p>
                    {/* <button
                      onClick={resetForm}
                      className="btn btn-primary"
                    >
                      Submit Another Feedback
                    </button> */}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Feedback;